















import { Component, Vue } from "vue-property-decorator";
import { mapGetters } from "vuex";
import { I18N } from "@/config";
import moment from "moment";

@Component({
  computed: {
    ...mapGetters("ui", ["language"]),
  },
})
export default class HeaderLanguagesDesktop extends Vue {
  private language: string;

  get languages() {
    return I18N.enabledLocales.filter((locale: string) => locale !== this.language);
  }

  private setLanguage(language: string) {
    this.$store.dispatch("ui/setLanguage", language);
    this.$i18n.locale = language;

    this.$store.dispatch("ui/setLocale", language);
    moment.locale(language);

    this.$store.dispatch("ui/setHeaderType", null);
  }
}
